import { Component, input, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ContentType, Voices } from '@mira-avant/mtlibs';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';
import { AzureService } from '../../../../services/azure-service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-azure-voices-dropdown-field',
	imports: [DropdownControl],
	standalone: true,
	templateUrl: './azure-voices-dropdown-field.html',
	styleUrl: './azure-voices-dropdown-field.scss',
})
export class AzureVoicesDropdownField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>([]);

	private sub?: Subscription;

	constructor(private asureService: AzureService) {
		this.sub = this.asureService.voices$.subscribe((voices: Voices[]) => {
			this.options.set(
				voices.flatMap(voiceGroup => voiceGroup.voices.map(voice => ({ value: voice, label: voice })))
			);
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
